import { STATUS_LABELS } from "./ShelfChips";
import { ComplexityChip } from "./ShelfChips";

const COLUMNS = ["ready", "claimed", "in_prep", "complete"];

export const BoardColumns = ({ byStatus }) => (
  <div className="grid gap-4 md:grid-cols-2 xl:grid-cols-3" data-testid="board-columns">
    {COLUMNS.map((status) => {
      const items = byStatus[status] || [];
      return (
        <div key={status} className="rounded-xl border border-border bg-muted/30 p-3" data-testid={`board-col-${status}`}>
          <div className="flex items-center justify-between mb-2.5 px-1">
            <span className="text-[11px] font-semibold uppercase tracking-[0.12em] text-muted-foreground">
              {STATUS_LABELS[status]}
            </span>
            <span className="text-xs font-semibold tabular-nums text-muted-foreground">{items.length}</span>
          </div>
          <div className="space-y-2 max-h-[420px] overflow-y-auto">
            {items.length === 0 && <p className="text-xs text-muted-foreground px-1 py-3">Empty</p>}
            {items.map((i) => (
              <div
                key={i.id}
                className="rounded-lg bg-card border border-border px-3 py-2.5"
                data-testid={`board-item-${i.id}`}
              >
                <div className="flex items-start justify-between gap-2">
                  <p className="text-sm font-medium break-words">
                    {i.client_id && <span className="font-mono text-muted-foreground mr-1.5">{i.client_id}</span>}
                    {i.client_name}
                  </p>
                  <ComplexityChip value={i.complexity} />
                </div>
                <p className="text-[11px] text-muted-foreground font-mono mt-0.5">
                  {i.work_label}
                  {i.claimed_by_name ? ` · ${i.claimed_by_name}` : ""}
                </p>
              </div>
            ))}
          </div>
        </div>
      );
    })}
  </div>
);
